export default __webpack_public_path__ + "static/home-keep-backstage-safe-27628aa0bfb50c3ddcf0cac5be9d00ac.png";